export default {
    addUser: 'Add User',
    buttonShareTip: 'Tip Menu',
    buyTokens: 'Buy Tokens',
    cancel: 'Cancel',
    change: 'Change',
    home: 'Home',
    insertDate: 'Insert Date',
    ok: 'Ok',
    purchaseTokens: 'Purchase Tokens',
    save: 'Save',
    search: 'Search',
    send: 'Send',
    submit: 'Submit',
}
